import { useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatestMovies, movies, TYPE_LABELS } from "@/lib/media";
import type { MovieType } from "@/lib/types";

const TABS: { key: MovieType | "all"; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "variety", label: "综艺" },
  { key: "animation", label: "动画" },
];

export default function LatestPicks() {
  const [tab, setTab] = useState<MovieType | "all">("all");
  const latest = getLatestMovies(8);
  const list = tab === "all" ? latest : movies.filter((movie) => movie.type === tab).slice(0, 8);

  return (
    <section className="shell mt-12 md:mt-16" aria-label="最新影视作品推荐">
      <SectionHeading
        eyebrow="Latest"
        title="最新影视作品"
        desc="按更新时间收录，剧情、演员与剧集信息同步更新"
        action={
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-100 p-1">
            {TABS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors md:text-[13px] ${
                  tab === item.key
                    ? "bg-background-50 text-primary-700"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        }
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} showOverview />
        ))}
      </div>
      <div className="mt-6 flex justify-center">
        <Link
          to={`/category/${tab === "all" ? "all" : tab}`}
          className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          查看全部{TYPE_LABELS[tab as MovieType] ?? "影视作品"}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </section>
  );
}